import type { FieldKey, FieldMap } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

export const updateFieldOptionAutoFormattingDisabled =
	(fieldKey: FieldKey, newValue: boolean) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ onFieldUpdateFailed, projectId, fieldRemote }: Props,
	): Promise<void> => {
		const state = getState();
		const field = state.fields[fieldKey];
		const oldValue = field.configuration?.optionAutoFormatDisabled;

		if (projectId === undefined) {
			return;
		}

		const fields: FieldMap = {
			...state.fields,
			[fieldKey]: {
				...field,
				configuration: {
					...field.configuration,
					optionAutoFormatDisabled: newValue,
				},
			},
		};

		setState({ fields });

		return fieldRemote
			.updateFieldConfiguration({
				fieldKey,
				oldConfiguration: oldValue !== undefined ? { optionAutoFormatDisabled: oldValue } : {},
				configuration: newValue !== undefined ? { optionAutoFormatDisabled: newValue } : {},
				type: 'updateFieldOptionAutoFormattingDisabled',
			})
			.catch((err) => {
				const currentState = getState();
				const currentFieldsData: FieldMap = {
					...currentState.fields,
					[fieldKey]: {
						...currentState.fields[fieldKey],
						configuration: {
							...currentState.fields[fieldKey].configuration,
							optionAutoFormatDisabled: oldValue,
						},
					},
				};

				setState({ fields: currentFieldsData });

				onFieldUpdateFailed(err);
			});
	};
